import actionTypes from "../action-types";
import { ClassEnrollmentType } from "../models/ClassEnrollment";

export const receiveClassEnrollments = (
  enrollments: Array<ClassEnrollmentType>
) => ({
  type: actionTypes.RECEIVE_CLASS_ENROLLMENTS,
  payload: {
    enrollments
  }
});

export const receiveClassEnrollment = (enrollment: ClassEnrollmentType) => ({
  type: actionTypes.RECEIVE_CLASS_ENROLLMENT,
  payload: {
    enrollment
  }
});

export const deleteClassEnrollment = (classId: string) => ({
  type: actionTypes.DELETE_CLASS_ENROLLMENT,
  payload: {
    classId
  }
});

export const receiveChildClassEnrollments = (
  enrollments: Array<ClassEnrollmentType>
) => ({
  type: actionTypes.RECEIVE_CHILD_CLASS_ENROLLMENTS,
  payload: {
    enrollments
  }
});
